import { useEffect } from 'react'
import { isAnyOpsSectorEnabled, type WorkspaceModuleSource } from '../utils/workspaceModules'
import { subscribeOpsPrivacySettings } from '../services/opsPrivacyService'
import { recordWorkspaceOfflineMaxDays, DEFAULT_OFFLINE_MAX_DAYS } from '../services/offlineExpiry'

/**
 * R39 A12.a (X3): When a workspace with any ops sector on becomes the active workspace,
 * read ops_privacy_settings/{workspaceId} through opsPrivacyService, keep it live while active,
 * and call recordWorkspaceOfflineMaxDays. A missing doc counts as the default (7).
 */
export function useOpsWorkspaceOfflineLimit(
  activeWorkspace: (WorkspaceModuleSource & { id?: string }) | null | undefined,
): void {
  const activeWsId = activeWorkspace?.id
  const opsSectorActive = isAnyOpsSectorEnabled(activeWorkspace)

  useEffect(() => {
    if (!activeWsId || !opsSectorActive) return

    const unsubscribe = subscribeOpsPrivacySettings(activeWsId, (settings) => {
      const days = settings?.offlineMaxDays ?? DEFAULT_OFFLINE_MAX_DAYS
      recordWorkspaceOfflineMaxDays(activeWsId, days)
    })

    return () => {
      unsubscribe()
    }
  }, [activeWsId, opsSectorActive])
}
